import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import {A, E} from './util.mjs'
import * as c from './conf.mjs'
import * as d from './dat.mjs'
import * as n from './net.mjs'
import * as u from './util.mjs'
import * as ei from './elem-input.mjs'
import * as ef from './elem-form.mjs'
import * as eb from './elem-btn.mjs'
import * as em from './elem-misc.mjs'
import * as effc from './elem-form-field-checkbox.mjs'

export class Pref extends u.MixElemReinit(u.Elem) {
  static {dr.reg(this)}

  preinit() {
    this.pageDat().inp.get.units.pref = true

    return E(
      this,
      A.cls(`col-sta-sta w-full gap-lg --big-inputs`),
      new PrefFormSectionGeneral(this).preinit(),
      new PrefSectionFormCatsMain(this).preinit(),
      new PrefSectionFormCatsConcern(this).preinit(),
    )
  }

  async init() {
    await u.PromiseList.map(this.childNodes, u.initOpt)
    return this
  }

  async refresh() {
    this.replaceWith(await this.sprout().reinit())
  }
}

class PrefForm extends ef.SpecForm {
  pref() {return this.anc(Pref)}

  preinit() {
    this.pageDat().inp.get.units.pref = true
    this.pageDat().inp.get.units.forms.prefForm = true
    return this
  }

  initProps() {return this.initSubmit(this.getFormSpec())}
  drawFields() {return ef.specToFields(this, this.getFormSpec())}
  getEnt() {return a.optInst(this.buk().get?.units?.pref, d.AggPref)}
  getFormSpec() {return this.buk()?.get?.units?.forms?.prefForm}

  /*
  Automatically submit this form on any input change. Note that we don't bother
  rendering a submit button here. Motivation: this makes the UI simpler since
  this form has only boolean checkboxes. May reconsider if we add non-booleans
  in the future.
  */
  onChange(eve) {
    super.onChange(eve)
    this.exec(eve)
  }

  async perform(...src) {
    await super.perform(...src)
    notifySaved()
  }
}

class PrefFormSection extends PrefForm {
  get A() {return A.cls(`col-sta-sta w-full gap`)}
  pref() {return this.anc(Pref)}
  title() {}

  head() {
    const title = this.title()
    return a.vac(title) && E(`h2`, A.cls(`font-h5 wei-semi-bold`), title)
  }
}

class PrefFormSectionGeneral extends PrefFormSection {
  static {dr.reg(this)}
  title() {return `General Preferences`}

  init() {
    this.initProps()
    return E(this, this.A, this.head(), this.drawFields())
  }
}

// Tentative. TODO consider moving to `Notif`.
function notifySaved() {
  em.Notif
    .show(E(`div`, A.cls(c.CLS_TOAST_SUCCESS), `Saved!`))
    .removeAfter(a.after(c.DELAY_POPUP_SUCCESS))
}

export class PrefFormPersonalInfo extends PrefForm {
  static {dr.reg(this)}

  getFormSpec() {
    return super.getFormSpec().withOnlyFields(`isEmailPublic`, `isPhonePublic`)
  }

  init() {
    this.initFromSpec(this.getFormSpec())
    return E(this, A.cls(`gap`), this.drawFields())
  }
}

const MODE_GRID = `grid`
const MODE_LEVELS = `levels`

class PrefFormSectionCats extends PrefFormSection {
  /*
  TODO: if some `.entVals` are not displayed in `this.CatColl`, render an
  additional indicator. For example, `CatGrid` is unable to display categories
  outside of its particular level, which may be selected via `CatLevels`.
  */
  async init() {
    await this.catObs().valueTask()
    const notAllDisplayed = CatNotAllDisplayed()

    this.initProps()

    E(this, this.A,
      this.head(),
      new CatControls(this).init(),
      notAllDisplayed,
      new this.CatColl(this).init(),
    )

    const hasAll = u.isSuperset(this.checkedVals(), this.entVals())
    if (hasAll) notAllDisplayed.remove()
    return this
  }

  catObs() {return this.ctx.dat.categories}
  catsAll() {return this.catObs().value}
  // Caution: client-side sorting is an antipattern. This is a rare exception.
  levels() {return this.cat().levels().sorted()}
  cat() {throw u.errImplementInSubclass()}
  catColl() {return this.desc(this.CatColl)}
  search(val) {return this.catColl().search(val)}
  modeKey() {throw u.errImplementInSubclass()}
  modeRead() {return this.bank().get(this.modeKey()) || MODE_GRID}
  modeWrite(val) {this.bank().set(this.modeKey(), val).write()}
  modeDesc() {return this.modeRead() || `unknown`}
  fieldName() {throw u.errImplementInSubclass()}
  entVals() {return this.getEnt()?.[a.reqValidStr(this.fieldName())]}
  checkedVals() {return this.formData()[a.reqValidStr(this.fieldName())]}

  get CatColl() {
    const mode = this.modeRead()
    if (mode === MODE_GRID) return CatGrid
    if (mode === MODE_LEVELS) return CatLevels
    throw Error(`unknown mode ${a.show(mode)}`)
  }

  async modeCycle() {
    this.modeWrite(this.modeRead() === MODE_GRID ? MODE_LEVELS : MODE_GRID)
    await this.pref().refresh()
  }
}

class PrefSectionFormCatsMain extends PrefFormSectionCats {
  static {dr.reg(this)}
  title() {return `Categories`}
  cat() {return this.catsAll().catMain()}
  cats() {return this.catsAll().catsMainSimple()}
  modeKey() {return c.DISK_KEY_OPT_CATS_MAIN_MODE}
  fieldName() {return `mainCategoryIds`}
}

class PrefSectionFormCatsConcern extends PrefFormSectionCats {
  static {dr.reg(this)}
  title() {return `Concerns`}
  cat() {return this.catsAll().catConcern()}
  cats() {return this.catsAll().onlyConcern()}
  modeKey() {return c.DISK_KEY_OPT_CATS_CONCERN_MODE}
  fieldName() {return `concernCategoryIds`}
}

class CatColl extends u.Elem {
  search(text) {
    for (const val of this.descs(CatCheckbox)) val.search(text)
  }
}

// TODO: bigger click targets, use padding instead of margins.
class CatGrid extends CatColl {
  static {dr.reg(this)}
  get A() {return A.cls(`grid-flex --default row-4 t-md-row-3 m-md-row-2`)}

  init() {
    return E(
      this,
      this.A,
      a.arr(this.anc(PrefFormSectionCats).cats()).map(this.item, this),
    )
  }

  item(val) {return new CatCheckbox(this).init(val)}
}

class CatLevels extends CatColl {
  static {dr.reg(this)}
  get A() {return A.cls(`row-sta-sta over-x-auto`)}

  init() {
    return E(
      this,
      this.A,
      a.arr(this.anc(PrefFormSectionCats).levels()).map(this.item, this)
    )
  }

  item(val) {return new CatLevel(this).init(val)}
}

/*
TODO: avoid displaying the header indicating level index if `d.CatLevels`
contains only one `d.CatLevel`.
*/
class CatLevel extends u.Elem {
  static {dr.reg(this)}
  get A() {return A.cls(`col-sta-sta gap`)}

  init(src) {
    a.reqInst(src, d.CatLevel)

    return E(
      this,
      this.A,
      E(
        `h2`,
        A.cls(`font-h6 wei-semi-bold`),
        `Depth `, src.getDepth(),
      ),
      a.arr(src).map(this.item, this),
    )
  }

  item(val) {return new CatGroup(this).init(val)}
}

class CatGroup extends u.Elem {
  static {dr.reg(this)}
  get A() {return A.cls(`col-sta-sta gap-tiny`)}

  init(src) {
    a.reqInst(src, d.CatGroup)

    return E(this, this.A,
      E(
        `h2`,
        A.cls(`font-h6 wei-semi-bold`),
        src.parentTitle(),
      ),
      a.arr(src).map(this.item, this),
    )
  }

  item(val) {return new CatCheckbox(this).init(val)}
}

class CatControls extends u.Elem {
  static {dr.reg(this)}
  get A() {return A.cls(`row-bet-sta w-full gap m-xl-col-sta-sta`)}

  init() {
    return E(
      this,
      this.A,
      new CatSearch(this).init(),
      new CatPrefViewModeBtnBig(this).init(),
    )
  }
}

class CatSearch extends ei.Input {
  static {dr.reg(this)}
  get A() {return A.cls(`form-input`).type(`search`).placeholder(`🔎 Search`)}
  init() {return E(this, this.A)}
  connectedCallback() {this.oninput = this.onInput}
  onInput() {this.anc(PrefFormSectionCats).search(this.value)}
}

class CatPrefViewModeBtn extends eb.Btn {
  async perform() {await this.anc(PrefFormSectionCats).modeCycle()}
}

class CatPrefViewModeBtnBig extends CatPrefViewModeBtn {
  static {dr.reg(this)}
  get A() {return super.A.cls(`btn-border miw-col-1x5 --big ws-nowrap`)}

  init() {
    super.init()
    return E(this, {}, `View mode: `, this.anc(PrefFormSectionCats).modeDesc())
  }
}

class CatPrefViewModeBtnInline extends CatPrefViewModeBtn {
  static {dr.reg(this)}
  get A() {return super.A.cls(`busy-fg-accent`)}
}

class CatCheckbox extends effc.FormFieldCheckboxMulti {
  static {dr.reg(this)}
  get A() {return super.A.cls(`aria-label-sparse`)}
  title() {return this.label()?.textContent}

  init(src) {
    a.reqInst(src, d.Category)
    const val = src.id
    const form = this.getForm()

    return E(this, A.tooltip(this.tooltipText(src)),
      new this.Input(this).init({
        name: form.anc(PrefFormSectionCats).fieldName(),
        value: val,
        checked: a.includes(form.entVals(), val),
      }),
      new this.Label(this).init(undefined, src.title),
    )
  }

  tooltipText(src) {
    a.reqInst(src, d.Category)
    const {recPersonCount, recArticleCount, recServiceCount} = src

    return a.vac(u.joinLines(
      a.vac(recPersonCount) && a.spaced(`Practitioners:`, recPersonCount),
      a.vac(recArticleCount) && a.spaced(`Articles:`, recArticleCount),
      a.vac(recServiceCount) && a.spaced(`Services:`, recServiceCount),
    ))
  }

  search(val) {
    if (!a.trim(val)) this.highlightNormal()
    else if (this.match(val)) this.highlightFound()
    else this.highlightNotFound()
  }

  match(val) {return u.searchTest(this.title(), val)}
  clsFound() {return `bg-accent-light`}
  clsNotFound() {return `opacity-0x5`}

  // TODO shorten code.
  highlightNormal() {
    this.classList.remove(this.clsFound())
    this.classList.remove(this.clsNotFound())
  }

  highlightFound() {
    this.classList.add(this.clsFound())
    this.classList.remove(this.clsNotFound())
  }

  highlightNotFound() {
    this.classList.remove(this.clsFound())
    this.classList.add(this.clsNotFound())
  }
}

function CatNotAllDisplayed() {
  return E(
    `span`,
    A.cls(`fg-warm-gray`),
    `Some preferences are not displayed. `,
    E(new CatPrefViewModeBtnInline().init(), {}, `Change the view mode`),
    ` to see more.`,
  )
}

export class ConsiderInterestsToggle extends effc.FormFieldBoolExecable {
  static {dr.reg(this)}

  // TODO convert to instance method.
  // Requires updating callsites.
  static preinit(ctx) {ctx.pageDat.inp.get.units.pref = true}

  get Label() {return effc.CheckboxLabelToggle}

  init(pref) {
    a.optInst(pref, d.AggPref)

    return E(this, this.A,
      new this.Input(this).init().setValue(!pref?.isIgnored),
      new this.Label(this).init(),
    )
  }

  async perform() {
    await n.fetchBuk(this.ctx, {
      act: {pref: {isIgnored: !this.input().getValue()}},
    })

    this.env.dat.clear()
    await this.env.updateCurrentPage()
  }
}
